<template>
  <div class="content systemlog">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
        <div class="content-body-header">
          <div class="left">
            <div class="title">{{$t('systemLog.severrityLv')}}</div>
            <div class="typecombo">
              <q-select class="q-select" :value="selectType" :options-array="menuOptions" @change="onMenuChange"></q-select>
            </div>
          </div>
          <div class="right">
            <div class="forminput search icon-search">
              <input name="filterDetail" type="text" v-model="searchText" class="form-control filterInput" :placeholder="$t('search')" @change="search" @keyup.enter="search">
            </div>
            <button class="q-button blue-btn-full" :title="$t('clear')" @click="onClearClick()">{{$t('clear')}}</button>
          </div>
        </div>
        <div class="group-table">
            <fixed-table ref="logTable" :data="filterLists" :use-page="true" :header-height="27" :show-count="10" :right-fills="0" @refresh="getLog">
                <div class="right-header" slot="right-header">
                    <column style="width: 10%;">{{$t('systemLog.severrityLv')}}</column>
                    <column style="width: 10%;">{{$t('systemLog.date')}}</column>
                    <column style="width: 10%;">{{$t('systemLog.time')}}</column>
                    <column style="width: 70%;">{{$t('systemLog.event')}}</column>
                </div>
                <div class="empty" v-show="filterLists.length == 0" slot="empty">
                  <div class="description">
                    <div class="form"></div>
                    <div class="message">{{$t('noResult')}}</div>
                  </div>
                </div>
                <template slot="rows" slot-scope="props">
                    <div class="link-row" v-if="filterLists.length > 0">
                        <row class="right" :props="props">
                            <div class="data icon" style="width: 10%;">
                              <span :class="props.data.val.MsgLevel | getIcon"></span>
                            </div>
                            <div class="data" style="width: 10%;">{{props.data.val.MsgTimeStamp | parseDate}}</div>
                            <div class="data" style="width: 10%;">{{props.data.val.MsgTimeStamp | parseTime}}</div>
                            <div class="data" style="width: 70%;text-align:left;">{{props.data.val.MsgText}}</div>
                        </row>
                    </div>
                </template>
            </fixed-table>
        </div>
    </div>
    <v-dialog/>
    <popup-confirm name="systemlog-clear-modal" :dialog-header="$t('systemLog.clearTitle')" :dialog-message="$t('systemLog.clearContent')" icon="w" type="c" :callback="goClear" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import moment from 'moment'
import qSelect from './module/Select.vue'
export default {
  name: 'SystemLog',
  components: {
    fixedTable,
    row,
    column,
    qSelect
  },
  filters: {
    parseDate: function (dateTime) {
      let time = moment(dateTime).format('YYYY-MM-DD')
      return time
    },
    parseTime: function (dateTime) {
      let time = moment(dateTime).format('hh:mm:ss')
      return time
    },
    getIcon: function (type) {
      let className = ''
      switch (type) {
        case 'informational':
          className = 'icon-info-border'
          break
        case 'notice':
          className = 'icon-remind'
          break
        case 'warning':
          className = 'icon-warning'
          break
        case 'error':
          className = 'icon-error'
          break
        default:
          className = 'icon-remind'
      }
      return className
    }
  },
  created: async function () {
    this.getLog()
  },
  data () {
    return {
      isShowLoading: false,
      filterLists: [],
      resultLists: [],
      selectType: 'all',
      imgClass: '',
      searchText: '',
      menuOptions: [
        { value: 'all', label: 'all' },
        { value: 'warning', label: 'systemLog.type.warning' },
        { value: 'error', label: 'systemLog.type.error' },
        { value: 'informational', label: 'systemLog.type.informational' },
        { value: 'notice', label: 'systemLog.type.notice' }
      ]
    }
  },
  watch: {
  },
  methods: {
    getLog: function () {
      var me = this
      me.filterLists = []
      me.isShowLoading = true
      try {
        this.getSystemLog(this.sysloglv)
          .then(res => {
            if (res.status === 200 && res.error == null) {
              me.resultLists = res.data.result.reverse()
              me.filterType()
              me.isShowLoading = false
            }
          })
          .catch(error => {
            this.$log.error(error)
            me.isShowLoading = false
          })
      } catch (err) {
        this.$log.error(err)
      }
    },
    search: function () {
      if (this.searchText) {
        let searchWord = this.searchText.toLowerCase()
        this.filterLists = []
        this.resultLists.forEach((item, index) => {
          let msgText = item.val.MsgText
          if (msgText && msgText.toLowerCase().indexOf(searchWord) > -1) {
            this.filterLists.push(item)
          }
        })
      } else {
        this.filterLists = this.resultLists
      }
    },
    filterType: function () {
      let self = this
      this.filterLists = []
      if (this.selectType === 'all') {
        this.filterLists = this.resultLists
      } else {
        this.resultLists.forEach((item, index) => {
          if (self.selectType === item.val.MsgLevel) {
            self.filterLists.push(item)
          }
        })
      }
    },
    onMenuChange: function (value) {
      this.selectType = value
      this.filterType()
    },
    onClearClick: function () {
      this.$modal.show('systemlog-clear-modal')
    },
    goClear: function () {
      this.$modal.hide('systemlog-clear-modal')
      let me = this
      this.clearSystemLog()
        .then(res => {
          me.getLog()
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    ...mapActions(['getSystemLog', 'clearSystemLog']),
    ...mapMutations(['openModal', 'closeModal'])
  },
  computed: {
    ...mapGetters(['getTopModalName']),
    ...mapState({
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/modal.scss';

.content.systemlog {
  position: relative;
  height: calc(100% - 60px);
  .content-body {
    height: 100%;
    > .content-body-header {
      display: flex;
      justify-content: space-between;
      padding: 25px 20px 12px 20px !important;
      >.left {
        color: #000000;
        display: flex;
        line-height: 30px;
        .title {
          font-size: 13px;
          color: #2F2F2F;
          line-height: 30px;
          display: inline-block;
        }
        .typecombo {
          height: 30px;
          margin-left: 5px;
          width: 250px;
          display: inline-block;
          position: relative;
        }
      }
      >.right {
        display: flex;
        .clear-btn {
          margin-right: 7px;
        }
      }
    }
    > .group-table {
      height: calc(100% - 70px);
      .data {
        position: relative;
        &.icon > span {
          vertical-align: middle;
          padding-left: calc(50% - 15px);
        }
        .icon-info-border {
          color: #0AB0EE;
        }
        .icon-warning {
          color: #D0021B;
        }
        .icon-error {
          color: #F5A623;
        }
        .icon-remind {
          color: #2847A0;
        }
      }
    }
    .q-select .display-label {
      font-size: 13px;
      color: #000;
    }
    .q-select {
      width: 150px;
      height: 30px;
      border: 1px solid #979797 !important;
      border-radius: 4px;
      vertical-align: middle;
      /deep/ .dropdown-menu {
        left: -1px;
        width: 200px;
        height: auto;
        overflow: auto;
      }
      /deep/ .display-label {
        font-size: 13px !important;
        color: #2F2F2F !important;
        line-height: 30px !important;
      }
      &::after {
        background-color: #000;
        top: -25px;
      }
    }
    .empty {
      position: relative;
      padding: 0 25px;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: #fff;
      border: 1px #e5e5e5 solid;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      >div {
        margin: auto;
        text-align: center;
      }
      .form {
        width: 211px;
        height: 157px;
        background-image: url("../assets/common/no_result.svg");
      }
      .message {
        font-size: 14px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemLog.vue